package ru.villawonka.app.presentation.screens.settings.compose.layout

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.colorsBackgroundColor1
import ru.villawonka.app.presentation.design.theme.colorsBackgroundColor2
import ru.villawonka.app.presentation.design.theme.colorsBackgroundColor3
import ru.villawonka.app.presentation.design.theme.colorsBackgroundColor4
import ru.villawonka.app.presentation.design.theme.colorsBackgroundColor5
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.design.theme.onSurfaceSecondary
import ru.villawonka.app.presentation.design.theme.surfaceLow
import ru.villawonka.app.presentation.screens.settings.compose.SettingsCallbacks
import ru.villawonka.app.presentation.screens.settings.compose.view.SettingsBlockView
import ru.villawonka.app.presentation.screens.settings.compose.view.SettingsIconView
import ru.villawonka.app.presentation.screens.settings.compose.view.SettingsItemPosition
import ru.villawonka.app.presentation.screens.settings.compose.view.SettingsItemView
import ru.villawonka.app.presentation.screens.settings.viewmodel.SettingsUIState
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_circle_question_16
import villawonka.composeapp.generated.resources.ic_currency_16
import villawonka.composeapp.generated.resources.ic_globe_16
import villawonka.composeapp.generated.resources.ic_map_pin_16
import villawonka.composeapp.generated.resources.ic_newspaper_16

@Composable
fun SettingsDataStateLayout(
    state: SettingsUIState.Data,
    callbacks: SettingsCallbacks
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(MaterialTheme.colors.surfaceLow)
            .verticalScroll(rememberScrollState())
    ) {
        AppSpacer(24.dp)
        Text(
            text = AppResources.strings.settingsTitle,
            style = AppTextStyles.titleMediumBold,
            color = MaterialTheme.colors.onSurfacePrimary,
            modifier = Modifier.padding(start = 16.dp)
        )
        AppSpacer(16.dp)
        SettingsBlockView {
            SettingsItemView(
                icon = {
                    SettingsIconView(
                        resource = Res.drawable.ic_globe_16,
                        backgroundColor = MaterialTheme.colors.colorsBackgroundColor1
                    )
                },
                key = AppResources.strings.settingsLanguageItem,
                value = state.language?.nativeString,
                position = SettingsItemPosition.FIRST,
                onClick = callbacks.onLanguageItemClick
            )
            SettingsItemView(
                icon = {
                    SettingsIconView(
                        resource = Res.drawable.ic_map_pin_16,
                        backgroundColor = MaterialTheme.colors.colorsBackgroundColor4
                    )
                },
                key = AppResources.strings.settingsCountryItem,
                value = state.country?.string,
                onClick = callbacks.onCountryItemClick
            )
            SettingsItemView(
                icon = {
                    SettingsIconView(
                        resource = Res.drawable.ic_currency_16,
                        backgroundColor = MaterialTheme.colors.colorsBackgroundColor5
                    )
                },
                key = AppResources.strings.settingsCurrencyItem,
                position = SettingsItemPosition.LAST,
                value = state.currency?.string,
                onClick = callbacks.onCurrencyItemClick
            )
        }
        AppSpacer(24.dp)
        SettingsBlockView {
            SettingsItemView(
                icon = {
                    SettingsIconView(
                        resource = Res.drawable.ic_newspaper_16,
                        backgroundColor = MaterialTheme.colors.colorsBackgroundColor3
                    )
                },
                key = AppResources.strings.settingsNewsItem,
                position = SettingsItemPosition.FIRST,
                onClick = callbacks.onServiceNewsItemClick
            )
            SettingsItemView(
                icon = {
                    SettingsIconView(
                        resource = Res.drawable.ic_circle_question_16,
                        backgroundColor = MaterialTheme.colors.colorsBackgroundColor2
                    )
                },
                key = AppResources.strings.settingsSupportItem,
                position = SettingsItemPosition.LAST,
                onClick = callbacks.onContactSupportItemClick
            )
        }
        AppSpacer(24.dp)
        SettingsBlockView {
            SettingsItemView(
                key = AppResources.strings.settingsPrivacyPolicyItem,
                position = SettingsItemPosition.FIRST,
                onClick = callbacks.onPrivacyPolicyItemClick
            )
            SettingsItemView(
                key = AppResources.strings.settingsTermsOfUseItem,
                position = SettingsItemPosition.LAST,
                onClick = callbacks.onTermsOfUseItemClick
            )
        }
        AppSpacer(16.dp)
        Text(
            text = state.appVersion,
            style = AppTextStyles.bodySmallRegular,
            color = MaterialTheme.colors.onSurfaceSecondary,
            modifier = Modifier.fillMaxWidth(),
            textAlign = TextAlign.Center
        )
    }
}